export const PROJECT_KEY = {
  single_ongoing_session: 'single_ongoing_session',
};
